module.exports = __webpack_public_path__ + "img/shipo-icon-arrow-down.f5dd40ea.svg";